import { Component, OnInit, Input, OnChanges, SimpleChange } from '@angular/core';
// import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { FormBuilder } from '@angular/forms';
import { PageGrid } from '../../../../utils/page-grid';
import { AuditService, ActivityTypes } from '../../../../services/audit.service';
import { DrowpdownFilterHandler } from '../../../../utils/utils';

@Component({
  selector: 'app-research-portal-stats-audit-data',
  templateUrl: './research-portal-stats-audit-data.component.html',
  styleUrls: ['./research-portal-stats-audit-data.component.scss'],
})
export class ResearchPortalStatsAuditDataComponent implements OnInit, OnChanges {
  // datePickerConfig: Partial<BsDatepickerConfig>;
  auditDataPageGrid: PageGrid;
  auditDataGridInProgress: boolean;
  moduleTypeMaster = ActivityTypes;
  moduleTypes = ActivityTypes;
  @Input('selectedActivityTypes') selectedActivityTypes: any;

  handleFilter = DrowpdownFilterHandler.bind(this)('moduleTypeMaster', 'moduleTypes');
  constructor(private fb: FormBuilder, private auditService: AuditService) {
    // this.datePickerConfig = Object.assign(
    //   {},
    //   {
    //     containerClass: 'theme-dark-blue',
    //     showWeekNumbers: false,
    //   }
    // );
  }

  ngOnChanges(changes: { [propKey: string]: SimpleChange }) {
    if (this.auditDataPageGrid && changes['selectedActivityTypes']) {
      this.auditDataPageGrid.filtersForm
        .get('modulesSelectedType')
        .setValue(ActivityTypes.find((e) => e.name === this.selectedActivityTypes).type);
      this.auditDataPageGrid.resetAndRefreshData();
    }
  }

  async ngOnInit() {
    await this.initializeAuditGrid();
  }

  // Intialize Audit Data PageGrids
  async initializeAuditGrid() {
    this.auditDataPageGrid = new PageGrid(this.fb)
      .setSources(
        async (listQuery) => {
          let filters = Object.assign({}, listQuery.filterFields);
          let count = 0;

          this.auditDataGridInProgress = true;

          count = await this.auditService.getAuditDataCount(
            (listQuery.filterValues.modulesSelectedType !== 'ALL' && listQuery.filterValues.modulesSelectedType) || '',
            listQuery.filterValues.searchClients,
            listQuery.page,
            listQuery.take,
            listQuery.sortField
          );

          this.auditDataGridInProgress = false;

          return { data: count };
        },
        async (listQuery) => {
          let data = [];
          let tempData = [];
          if (listQuery.total > 0) {
            this.auditDataGridInProgress = true;
            tempData = await this.auditService.getAuditData(
              (listQuery.filterValues.modulesSelectedType !== 'ALL' && listQuery.filterValues.modulesSelectedType) || '',
              listQuery.filterValues.searchClients,
              listQuery.page,
              listQuery.take,
              listQuery.sortField
            );
            data = tempData.map((item) => {
              let activity = ActivityTypes.find((e) => e.type === item.activity);
              if (activity) {
                item.type = activity.name;
              }

              return item;
            });
            this.auditDataGridInProgress = false;
          }
          return { data: [...data] };
        }
      )
      .setFilters({
        modulesSelectedType: [this.moduleTypes[0].type],
        searchClients: '',
      });
  }
}
